var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.297,
    height: 41.297,
    viewBox: "0 0 41.297 41.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "organization",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21933",
    "data-name": "Path 21933",
    d: "M28.566,1A8.083,8.083,0,0,0,20.5,9.13a8.27,8.27,0,0,0,1.549,4.775A6.636,6.636,0,0,1,24.5,7.969,4.744,4.744,0,0,1,28.566,5.71,4.938,4.938,0,0,1,32.7,7.969a6.636,6.636,0,0,1,2.452,5.936A8.132,8.132,0,0,0,28.566,1Z",
    transform: "translate(-6.917)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_251",
    "data-name": "Ellipse 251",
    cx: 3.613,
    cy: 3.613,
    r: 3.613,
    transform: "translate(18.035 7.001)",
    fill: "#f7901f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21934",
    "data-name": "Path 21934",
    d: "M28.53,57.905A8.132,8.132,0,0,0,35.112,45a6.453,6.453,0,0,1-2.452,5.872,4.854,4.854,0,0,1-4.13,2.258,4.938,4.938,0,0,1-4.13-2.258A6.586,6.586,0,0,1,21.949,45,8.132,8.132,0,0,0,28.53,57.905Z",
    transform: "translate(-6.882 -15.608)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_252",
    "data-name": "Ellipse 252",
    cx: 3.613,
    cy: 3.613,
    r: 3.613,
    transform: "translate(18.035 29.069)",
    fill: "#f7901f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21935",
    "data-name": "Path 21935",
    d: "M49.775,20.5A8.12,8.12,0,0,0,45,22.049,6.636,6.636,0,0,1,50.936,24.5a4.854,4.854,0,0,1,2.258,4.13A4.744,4.744,0,0,1,50.936,32.7,6.636,6.636,0,0,1,45,35.147,8.109,8.109,0,1,0,49.775,20.5Z",
    transform: "translate(-15.608 -6.917)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_253",
    "data-name": "Ellipse 253",
    cx: 3.613,
    cy: 3.613,
    r: 3.613,
    transform: "translate(29.069 18.035)",
    fill: "#f7901f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21936",
    "data-name": "Path 21936",
    d: "M9.13,36.661a8.12,8.12,0,0,0,4.775-1.549A6.636,6.636,0,0,1,7.969,32.66a4.9,4.9,0,0,1,0-8.259,6.519,6.519,0,0,1,5.872-2.452A8.12,8.12,0,0,0,9.066,20.4,8.13,8.13,0,0,0,9.13,36.661Z",
    transform: "translate(0 -6.882)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_254",
    "data-name": "Ellipse 254",
    cx: 3.613,
    cy: 3.613,
    r: 3.613,
    transform: "translate(7.001 18.035)",
    fill: "#f7901f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.37f1276c192d9e1a74a6aa3d7bd9cfdd.svg";
export { ForwardRef as ReactComponent };